<template>
    <div class="wrap-personnel animate__animated animate__fadeIn">
        <div class="dialog_addperson" v-if="show">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="title"
                :fullscreen="true" :visible.sync="show" center :before-close="fnClosePersonnel">
                <!-- ****************** 左边部分 ***************** -->
                <div class="left-item item">
                    <div class="row">
                        <div class="row-item">参数说明</div>
                        <div class="row-item">参数值</div>
                    </div>
                    <div class="row">
                        <div class="row-item" style="color:#F56C6C;">*身份证号</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" placeholder="正确输入身份证号将自动搜索人员数据库"
                                v-model="formData.idcard" @input="fnSearchPersonnelDatabase(formData.idcard)">
                            </el-input>
                            <div slot="reference" style="color:#E6A23C;margin-left: 10px;cursor:pointer;">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*姓名</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.name"
                                :filter-method="searchPersonnelDatabaseNameFilter" style="border-radius: 0;"
                                :disabled="path == 'personnelAudit'" clearable filterable placeholder="请输入全名,不支持模糊搜索"
                                ref="searchPersonnelRef" :no-data-text="notPersonnelText" @change="fnChangePersonnel">
                                <el-option v-for="item in searchPersonnelDatabaseName" :label="item.idcard"
                                    :value="item" style="height: 65px;">
                                    <img :src="item.photo"
                                        style="float: left;width: 60px;height: 60px;border-radius: 50%;margin:2px 15px 2px 0;" />
                                    <span style="float: left;line-height: 60px;color: #8492a6;">{{ item.idcard }}</span>
                                </el-option>
                            </el-select>
                            <el-button :disabled="path == 'personnelAudit'" size="mini" type="primary"
                                @click="fnSearchPersonnelDatabaseName" style="margin-left: 10px;">搜索人员库</el-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*性别</div>
                        <div class="row-item">
                            <el-radio-group :disabled="path == 'personnelAudit'" v-model="formData.sex">
                                <el-radio :label="1">男</el-radio>
                                <el-radio :label="0">女</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">户籍所在地</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" placeholder="请输入户籍所在地"
                                v-model="formData.address"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">卡号</div>
                        <div class="row-item">
                            <el-input placeholder="请输入卡号" v-model="formData.card_no"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*所属部门(班组)</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.department" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in teamList" :key="item.id" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*职位(工种)</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.position" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in workList" :key="item.id" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*联系电话</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" placeholder="请输入联系电话"
                                v-model="formData.phone"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">签发机关</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" placeholder="请输入签发机关"
                                v-model="formData.cert_org"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">证件有效期</div>
                        <div class="row-item">
                            <div v-if="showDate">
                                <el-date-picker :disabled="path == 'personnelAudit'" v-model="formData.validity_period"
                                    value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期"
                                    end-placeholder="结束日期" unlink-panels placeholder="选择日期"></el-date-picker>
                                <el-button size="mini" :disabled="path == 'personnelAudit'" type="primary"
                                    @click="showDate = !showDate">是否长期</el-button>
                            </div>
                            <div v-else>
                                <el-date-picker :disabled="path == 'personnelAudit'" v-model="dateStart"
                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                                <el-input v-model="dateEnd" :disabled="true"
                                    style="backgroud-color: rgba(77, 180, 244, 0.7); width:220px;display: inline-block;">
                                </el-input>
                                <el-button size="mini" :disabled="path == 'personnelAudit'" type="primary"
                                    @click="showDate = !showDate">是否长期</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">出生年月</div>
                        <div class="row-item">
                            <el-date-picker :disabled="path == 'personnelAudit'" value-format="yyyy-MM-dd"
                                v-model="formData.birthday" type="date" placeholder="选择日期"></el-date-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">民族</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" placeholder="请输入民族"
                                v-model="formData.nation"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">是否上传</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.is_need_upload">
                                <el-radio :label="1">上传</el-radio>
                                <el-radio :label="0">不传</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <!-- ****************** 右边部分 ***************** -->
                <div class="right-item item">
                    <div class="row">
                        <div class="row-item">参数说明</div>
                        <div class="row-item">参数值</div>
                    </div>
                    <div class="row">
                        <div class="row-item">身份证头像</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'id_card_pic');}"
                                :show-file-list="false">
                                <img v-if="formData.id_card_pic" :src="formData.id_card_pic" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">身份证照片正面</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'id_card_pic_positive');}"
                                :show-file-list="false">
                                <img v-if="formData.id_card_pic_positive" :src="formData.id_card_pic_positive"
                                    class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button type="primary" :disabled="path == 'personnelAudit'"
                                @click="fnOpenCameraPage('id_card_pic_positive')">摄像头抓拍</el-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">身份证照片反面</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'id_card_pic_negative');}"
                                :show-file-list="false">
                                <img v-if="formData.id_card_pic_negative" :src="formData.id_card_pic_negative"
                                    class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button type="primary" :disabled="path == 'personnelAudit'"
                                @click="fnOpenCameraPage('id_card_pic_negative')">摄像头抓拍</el-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">现场人员可见光照</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'photo');}"
                                :show-file-list="false">
                                <img v-if="formData.photo" :src="formData.photo" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button type="primary" :disabled="path == 'personnelAudit'"
                                @click="fnOpenCameraPage('photo')">摄像头抓拍</el-button>
                            <span style="width: 40%; display: inline-block; vertical-align: middle"
                                :style="{ color: faceVerifRes.indexOf('成功') != -1 ? '' : 'red' }">{{ faceVerifRes }}</span>
                        </div>
                    </div>
                </div>
                <div slot="footer" v-if="path == 'personnelAudit'" class="dialog-footer printhide">
                    <div class="btn_line">
                        <div class="search-btn red" @click="fnClosePersonnel"><span>取消</span></div>
                        <!-- <div class="search-btn" @click="fnAddPersonnel"><span>审核通过</span></div> -->
                        <div class="search-btn" @click="fnGetPerisBlack"><span>审核通过</span></div>
                        <div class="search-btn orange" @click="fnAuditNot"><span>审核不通过</span></div>
                    </div>
                </div>
                <div slot="footer" v-else class="dialog-footer btn_line printhide">
                    <div class="btn_line">
                        <div class="search-btn red" @click="fnClosePersonnel"><span>取消</span></div>
                        <div class="search-btn orange" @click="fnReadCard"><span>读取身份证信息</span></div>
                        <!-- <div class="search-btn" @click="fnAddPersonnel"><span>保存</span></div> -->
                        <div class="search-btn" @click="fnGetPerisBlack"><span>保存</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 摄像头抓拍弹窗 -->
        <div class="dialog_camera">
            <el-dialog :modal="false" class="camera-photo" title="摄像头抓拍" :visible.sync="cameraIsShow" center
                @close="fnCloseCamera">
                <div class="photo-box">
                    <video id="cameraVideo" width="400px" height="300px"></video>
                    <canvas id="cameraCanvas" width="400px" height="300px"></canvas>
                    <div class="identify-result">{{ faceVerifRes }}</div>
                </div>
                <div slot="footer" class="dialog-footer btn_line">
                    <div class="search-btn" @click="fnCloseCameraWin"><span>取消</span></div>
                    <div class="search-btn red" @click="fnSnap"><span>拍 照</span></div>
                </div>
            </el-dialog>
        </div>
        <!-- 人员下发失败信息弹窗 -->
        <div class="dialog_isBlack" v-if="isBlackShow">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="提示信息"
                :visible.sync="isBlackShow" center>
                <div>该人员在人员黑名单，原因：{{ blackMsg }}，是否继续保存?</div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="fnClosePersonnel"><span>否</span></div>
                        <div class="search-btn" @click="fnAddPersonnel"><span>是</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import sha1 from 'js-sha1';
    import APP from '@/utils/base';
    import request from '@/utils/request';
    // import DefaultSet from '@/configure/default';
    import {
        fnUpload
    } from '@/utils/upload';
    import {
        Loading
    } from 'element-ui';
    import {
        fnCookie
    } from '@/utils/localStorage';
    import {
        getUserInfo
    } from '@/utils/auth';
    import * as imageConversion from 'image-conversion';

    export default {
        // setData 和 path 为 人员审核页面传参 path = 'personnelAudit'
        props: ['editInfo', 'setData', 'path'],
        data() {
            return {
                searchPersonnelDatabaseName: [], // 搜索人员库
                notPersonnelText: '请点击右侧按钮搜索',
                AuditData: {
                    // 人员审核编辑信息
                    personnel_id: null,
                    explain: '',
                    status: ''
                },
                isBlackShow: false,
                show: true, // 人员编辑弹窗
                mediaStreamTrack: null, // 摄像头操作
                cameraIsShow: false, // 摄像头抓拍弹窗
                title: '编辑人员', // 页面标题
                teamList: [],
                workList: [],
                faceVerifRes: '', // 人脸验证结果
                showDate: true,
                dateStart: '',
                dateEnd: '长期',
                formData: {
                    id: '',
                    name: '',
                    sex: 1,
                    address: '',
                    card_no: '',
                    department: '',
                    position: '',
                    phone: '',
                    idcard: '',
                    idcard_sha1: '',
                    cert_org: '',
                    validity_period: '',
                    birthday: '',
                    nation: '',
                    is_need_upload: 1, // 是否需要上传
                    id_card_pic: '', // 身份证头像
                    id_card_pic_positive: '', // 身份证正面照
                    id_card_pic_negative: '', // 身份证反面照,
                    photo: '' // 现场人员可见光照片
                },
                blackMsg: ''
            };
        },
        created() {
            this.fnInit();
            // 人员审核页面参数
            if (this.setData) {
                this.AuditData.personnel_id = this.setData.personnel_id;
                this.AuditData.explain = this.setData.explain;
                this.AuditData.status = this.setData.status;
            }
            document.getElementsByClassName('menu_bar')[0].style.display = 'none';
            document.getElementsByClassName('copy_box')[0].style.display = 'none';
        },
        beforeDestroy() {
            this.fnCloseCamera();
        },
        destroyed() {
            document.getElementsByClassName('menu_bar')[0].style.display = '';
            document.getElementsByClassName('copy_box')[0].style.display = '';
        },
        methods: {
            // 初始化
            fnInit() {
                // 获取班组
                this.fnGetTeam();
                // 获取工种
                this.fnGetWork();
                // this.workList = DefaultSet.workType;
                if (this.path == 'personnelAudit') this.title = '审核人员';
                // 编辑时需要对传过来的数据进行处理
                if (this.editInfo && this.editInfo.id) {
                    for (let _key in this.editInfo) {
                        if (_key != 'project_name') {
                            if (_key == 'validity_period') {
                                if (this.editInfo[_key]) {
                                    let _validity_period = this.editInfo[_key].split('-');
                                    if (_validity_period[1] == '长期') {
                                        this.showDate = false;
                                        this.dateStart = APP.fnDateAddEm_public(_validity_period[0]);
                                        this.dateEnd = _validity_period[1];
                                    } else {
                                        this.showDate = true;
                                        this.formData[_key] = [APP.fnDateAddEm_public(_validity_period[0]), APP
                                            .fnDateAddEm_public(_validity_period[1])
                                        ];
                                    }
                                }
                            } else {
                                this.formData[_key] = this.editInfo[_key];
                            }
                        }
                    }
                } else {
                    this.title = '添加人员';
                    if (this.editInfo && (this.editInfo['photo'] || this.editInfo['card_no'])) {
                        for (let _key in this.editInfo) {
                            this.formData[_key] = this.editInfo[_key];

                            if (_key == 'photo' && this.editInfo[_key]) {
                                let _photo = APP.fnBase64ToFile(this.editInfo[_key]);
                                this.beforeCardPicUpload(_photo, 'photo');
                            }
                        }
                    } else {
                        this.formData.id = '';
                    }
                }
            },
            // 关闭添加人员弹窗
            fnClosePersonnel() {
                this.isBlackShow = false;
                if (this.path == 'personnelAudit') {
                    this.$parent.fnOpenAddOrEdit();
                } else {
                    this.$parent.fnCloseAddOrEdit();
                }
            },
            // 获取班组信息
            fnGetTeam() {
                request({
                        url: 'team/getTeam',
                        method: 'GET'
                    })
                    .then(res => {
                        let _teamList = [];
                        res.data.forEach(_item => {
                            _teamList.push({
                                name: _item.name,
                                id: _item.id,
                                value: _item.id + '#' + _item.name
                            });
                        });
                        this.teamList = _teamList;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 获取工种
            fnGetWork() {
                request({
                        url: 'personnel/getWork',
                        method: 'GET',
                        params: {
                            region_id: 0
                        }
                    })
                    .then(res => {
                        let _workList = [];
                        res.data.forEach(_item => {
                            _workList.push({
                                name: _item.name,
                                id: _item.id,
                                value: _item.id + '#' + _item.name
                            });
                        });
                        this.workList = _workList;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 上传身份证头像
            beforeCardPicUpload(_file, _el) {
                let _loadingInstance = Loading.service({
                    fullscreen: true,
                    background: 'rgba(255,255,255,0.7)',
                    spinner: 'el-icon-loading',
                    text: _el == 'photo' ? '人脸验证中…' : '图片上传中'
                });
                let _that = this;
                // 把图片文件压缩到200kb
                imageConversion.compressAccurately(_file, 200).then(_res => {
                    let reader = new FileReader();
                    reader.onload = function() {
                        let _base64 = this.result;
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile(_base64);
                        let formData = new FormData();
                        formData.append('file', _fileObject);
                        formData.append('type', 'image');
                        if (_base64.indexOf('data:image/') != -1) {
                            _base64 = _base64.split(',')[1];
                        }
                        fnUpload(formData, res => {
                            if (_el == 'photo') {
                                request({
                                        notLoading: true,
                                        url: 'file/getFaceInfo',
                                        method: 'POST',
                                        data: {
                                            img: _base64
                                        }
                                    })
                                    .then(res => {
                                        if (res.code == APP.HTTP_STATUS.SUCCESS) {
                                            _loadingInstance.close();
                                            _that.faceVerifRes = '人脸照验证成功';
                                            _that.formData[_el] = res.data;
                                        } else {
                                            _loadingInstance.close();
                                            _that.faceVerifRes = res.data;
                                        }
                                    })
                                    .catch(err => {
                                        _loadingInstance.close();
                                        _that.faceVerifRes = err.data;
                                    });
                            } else {
                                _that.formData[_el] = res.data.file_url;
                                _loadingInstance.close();
                            }
                        });
                    };
                    reader.readAsDataURL(_res);
                });
                return false; // 阻止组件自动上传图片
            },
            // 打开摄像头拍照页面
            fnOpenCameraPage(_el) {
                this.cameraEl = _el; // 拍照类型（身份证头像，身份证正面……）
                this.cameraIsShow = true;
                this.faceVerifRes = '';
                let _video = document.getElementById('cameraVideo');
                let _canvas = document.getElementById('cameraCanvas');
                /* 清空视频和画布 */
                if (_canvas) {
                    let _context = _canvas.getContext('2d');
                    _context.clearRect(0, 0, _canvas.width, _canvas.height);
                }
                if (_video) {
                    _video.src = '';
                }
                setTimeout(() => {
                    this.fnOpenCamera();
                }, 300);
            },
            // 打开摄像头
            fnOpenCamera() {
                let _that = this;
                let _video = document.getElementById('cameraVideo');
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices
                        .getUserMedia({
                            video: true,
                            audio: false
                        })
                        .then(function(stream) {
                            _that.mediaStreamTrack = typeof stream.stop === 'function' ? stream : stream
                                .getTracks()[0];
                            _video.srcObject = stream;
                            _video.play();
                        })
                        .catch(function(err) {
                            console.log(err);
                        });
                } else if (navigator.getMedia) {
                    navigator
                        .getMedia({
                            video: true,
                            audio: false
                        })
                        .then(function(stream) {
                            _that.mediaStreamTrack = stream.getTracks()[0];
                            _video.srcObject = stream;
                            _video.play();
                        })
                        .catch(function(err) {
                            console.log(err);
                        });
                } else {
                    this.$message.warning('您的浏览器不支持调用摄像头拍照，请切换其他浏览器');
                }
            },
            // 关闭摄像头
            fnCloseCamera() {
                this.mediaStreamTrack && this.mediaStreamTrack.stop();
            },
            // 拍照
            fnSnap() {
                let _that = this;
                let _canvas = document.getElementById('cameraCanvas');
                let _context = _canvas.getContext('2d');
                let _video = document.getElementById('cameraVideo');
                _context.drawImage(_video, 0, 0, 400, 300);
                // 只有可见光照需要验证是否有人脸
                if (_that.cameraEl == 'photo') {
                    let _loadingInstance = Loading.service({
                        fullscreen: true,
                        background: 'rgba(255,255,255,0.7)',
                        spinner: 'el-icon-loading',
                        text: '人脸验证中…'
                    });
                    let _base64 = _canvas.toDataURL(_canvas, 0.3); // 压缩图片质量
                    let _fileObject = APP.fnBase64ToFile(_base64);
                    // 图片压缩到 200kb
                    imageConversion.compressAccurately(_fileObject, 200).then(_res => {
                        let reader = new FileReader();
                        reader.onload = function() {
                            let _base64 = this.result;
                            if (_base64.indexOf('data:image/') != -1) {
                                _base64 = _base64.split(',')[1];
                            }
                            request({
                                    notLoading: true,
                                    url: 'file/getFaceInfo',
                                    method: 'POST',
                                    data: {
                                        img: _base64
                                    }
                                })
                                .then(res => {
                                    _loadingInstance.close();
                                    _that.faceVerifRes = '人脸照验证成功';
                                    _that.formData[_that.cameraEl] = res.data;
                                    _that.fnSavePhoto();
                                })
                                .catch(err => {
                                    _loadingInstance.close();
                                    _that.faceVerifRes = err.data;
                                });
                        };
                        reader.readAsDataURL(_res);
                    });
                } else {
                    this.fnSavePhoto();
                }
            },
            // 保存拍照图片并转为base64
            fnSavePhoto() {
                let _canvas = document.getElementById('cameraCanvas');
                let _base64 = _canvas.toDataURL(_canvas, 0.3); // 压缩图片质量
                if (this.cameraEl != 'photo') {
                    // base64转文件流对象
                    let _fileObject = APP.fnBase64ToFile(_base64);
                    let formData = new FormData();
                    formData.append('file', _fileObject);
                    formData.append('type', 'image');
                    fnUpload(formData, res => {
                        this.formData[this.cameraEl] = res.data.file_url;
                    });
                }
                this.fnCloseCamera(); // 关闭摄像头
                this.cameraIsShow = false; // 关闭拍照弹窗
            },
            // 关闭拍照弹窗
            fnCloseCameraWin() {
                this.fnCloseCamera(); // 关闭摄像头
                this.cameraIsShow = false; // 关闭拍照弹窗
            },
            // 连接身份证阅读器
            fnConnectCert(_cb) {
                if (typeof CertCtl.connect === 'undefined') {
                    this.$alert(
                        "<p>您的设备暂不支持身份证读取，请确认是否安装阅读器插件（点击此处下载:<a style='color: blue;text-underline: blue' href='https://cqzgzl.oss-cn-chengdu.aliyuncs.com/Trivia/%E4%BA%8C%E4%BB%A3%E5%B1%85%E6%B0%91%E8%BA%AB%E4%BB%BD%E8%AF%81%E8%AF%BB%E5%86%99%E5%99%A8%E6%8E%A5%E5%8F%A3%202.5.0.exe'>下载身份证阅读器</a>），或更换至<a style='color: blue;text-underline: blue' href='https://browser.360.cn/ee/'>360极速浏览器</a>,并切换至极速模式进行身份证读取</p>",
                        '提示', {
                            center: true,
                            dangerouslyUseHTMLString: true
                        }
                    );
                    return;
                }
                let _strResult = CertCtl.connect();
                let jsValue = eval('(' + _strResult + ')');
                if (jsValue.resultFlag == 0) {
                    _cb && _cb();
                } else {
                    this.$alert(
                        "<p>身份证阅读器连接失败，请确认是否安装阅读器插件（点击此处下载:<a style='color: blue;text-underline: blue' href='https://cqzgzl.oss-cn-chengdu.aliyuncs.com/Trivia/%E4%BA%8C%E4%BB%A3%E5%B1%85%E6%B0%91%E8%BA%AB%E4%BB%BD%E8%AF%81%E8%AF%BB%E5%86%99%E5%99%A8%E6%8E%A5%E5%8F%A3%202.5.0.exe'>下载身份证阅读器</a>），请更换至360极速浏览器,并切换至极速模式进行身份证读取</p>",
                        '提示', {
                            center: true,
                            dangerouslyUseHTMLString: true
                        }
                    );
                }
            },
            searchPersonnelDatabaseNameFilter(_v) {
                this.formData.name = _v
            },
            fnChangePersonnel(_data) {
                APP.fnChangePersonnel(this, _data, 'formData')
            },
            fnSearchPersonnelDatabaseName() {
                APP.fnSearchPersonnelDatabaseName(this.formData.name, this)
            },
            fnSearchPersonnelDatabase(_idcard, _read) {
                APP.fnSearchPersonnelDatabase(_idcard, _read, this, 'formData')
            },
            // 读取身份证信息
            fnReadCard() {
                this.formData.idcard = '500381199410020412'
                this.fnConnectCert(res => {
                    let _strResult = CertCtl.readCert();
                    let _jsValue = eval('(' + _strResult + ')');
                    if (_jsValue.resultFlag == 0) {
                        this.$message.success('身份证信息读取成功');
                        let _birthday = APP.fnDateAddEm_public(_jsValue.resultContent.bornDay);
                        let _validityPeriod = [APP.fnDateAddEm_public(_jsValue.resultContent.effDate), APP
                            .fnDateAddEm_public(_jsValue.resultContent.expDate)
                        ];
                        this.formData.name = _jsValue.resultContent.partyName;
                        this.formData.sex = _jsValue.resultContent.gender == 0 ? 2 : 1;
                        this.formData.address = _jsValue.resultContent.certAddress;
                        this.formData.idcard = _jsValue.resultContent.certNumber;
                        this.fnSearchPersonnelDatabase(this.formData.idcard, 1);
                        this.formData.cert_org = _jsValue.resultContent.certOrg;
                        if (_validityPeriod[1] == '长期') {
                            this.dateStart = _validityPeriod[0];
                            this.dateEnd = _validityPeriod[1];
                            this.showDate = false;
                        } else {
                            this.showDate = true;
                            this.formData.validity_period = _validityPeriod;
                        }
                        this.formData.birthday = _birthday;
                        this.formData.nation = _jsValue.resultContent.nation;
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile('data:image/png;base64,' + _jsValue.resultContent
                            .identityPic);
                        let formData = new FormData();
                        formData.append('file', _fileObject);
                        formData.append('type', 'image');
                        fnUpload(formData, res => {
                            this.formData.id_card_pic = res.data.file_url;
                        });
                    } else {
                        this.$message('身份证读取失败');
                    }
                });
            },
            // 判断人员是否在黑名单
            fnGetPerisBlack() {
                if (!this.formData.idcard) {
                    return this.$message.warning('请输入身份证号！');
                }
                request({
                        url: 'blacklist/judge',
                        method: 'GET',
                        params: {
                            idcard: this.formData.idcard
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            this.blackMsg = res.data;
                            this.isBlackShow = true;
                        } else {
                            this.fnAddPersonnel();
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 添加人员
            fnAddPersonnel() {
                this.isBlackShow = false;
                // 需要验证的字段
                let _needField = {
                    name: '姓名',
                    sex: '性别',
                    department: '所属部门',
                    position: '所属职位',
                    phone: '手机号码',
                    idcard: '身份证号'
                };
                for (let _key in _needField) {
                    if (this.formData[_key] === null || this.formData[_key] === '' || this.formData[_key] ===
                        undefined) {
                        this.$message.warning('人员' + _needField[_key] + '不能为空');
                        return;
                    }
                }
                // 正则匹配手机号
                const reg = /^1[3-9]\d{9}$/;
                if (!reg.test(this.formData.phone)) {
                    this.$message.warning('请输入正确的手机号');
                    return;
                }
                // 判断如果有人员可见光照 照片上传是否正确
                if (this.formData.photo !== '') {
                    if (this.faceVerifRes !== '' && this.faceVerifRes !== '人脸照验证成功') {
                        this.$message.warning('人员人脸照识别不成功');
                        return;
                    }
                }
                // 判断身份证有效期是否为长期所传参数
                if (this.showDate) {
                    let _validity_period = this.formData.validity_period;
                    if (_validity_period) {
                        this.formData.validity_period = APP.fnDateReduceEm_public(_validity_period[0]) + '-' + APP
                            .fnDateReduceEm_public(_validity_period[1]);
                    }
                } else {
                    this.formData.validity_period = APP.fnDateReduceEm_public(this.dateStart) + '-' + this.dateEnd;
                }

                this.formData.idcard = this.formData.idcard.toLowerCase(); // 身份证号转小写
                // 如果身份证不包含*号 则加密处理 否则不加密
                if (this.formData.idcard.indexOf('*') == -1) {
                    this.formData.idcard_sha1 = sha1(this.formData.idcard); // 身份证sha1加密
                }
                // 去掉卡号前面的0
                let regex = /^[0]+/;
                if (this.formData.card_no) {
                    this.formData.card_no = this.formData.card_no.replace(regex, '');
                }

                let _personnelInfo = this.formData;
                delete _personnelInfo.selected;
                request({
                        url: 'personnel/addEditPersonnel',
                        method: 'POST',
                        data: {
                            personnel_info: JSON.stringify(_personnelInfo)
                        }
                    })
                    .then(res => {
                        // 人员审核页面操作
                        // 审核通过
                        if (this.path == 'personnelAudit') {
                            this.$parent.getInout(this.AuditData);
                            this.$parent.fnOpenAddOrEdit();
                        } else {
                            // 正常人员页面操作
                            this.$message.success(res.data);
                            this.$parent.fnCloseAddOrEdit();
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 人员审核页面操作
            // 审核不通过
            fnAuditNot() {
                this.$parent.getNoInout(this.AuditData);
                this.$parent.fnOpenAddOrEdit();
            }
        }
    };
</script>

<style scoped lang="scss" type="text/scss">
    @import '~@/styles/mixin.scss';
.btn_line {
  @include flex-box(center, center);
  width: 100%;
}
.dialog_addperson {
  >>> .el-dialog {
    @include flex-box($direction: column);
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  >>> .el-dialog__body {
    @include flex-box();
    display: -webkit-box;
    padding-bottom: 80px;
  }
  >>> .avatar-uploader {
    line-height: 100px;
    margin-right: 10px;
    img {
      width: 98px;
      height: 98px;
      border-radius: 2px;
    }
  }
  >>> .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  // 按钮样式
  >>> .el-button {
    width: 110px;
    height: 40px;
    background: url(../../../../assets/img/btn_bg_bsm.png) no-repeat;
    background-size: 100% 100%;
    border: none;
  }
  // 上传图片样式
  >>> .el-upload--picture-card {
    background-color: rgba(9, 17, 32, 0.5);
  }
  >>> .el-input__inner {
    width: 280px;
    height: 30px;
    border-radius: 2px;
    border: none;
    color: rgba(77, 180, 244, 0.7);
    background-color: rgba(77, 180, 244, 0.2);
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  >>> .el-select {
    .el-input {
      .el-select__caret {
        color: rgba(77, 180, 244, 0.7);
      }
    }
  }
  >>> .el-select-dropdown {
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(77, 180, 244, 1);
  }
  >>> .popper__arrow {
    border-bottom-color: rgba(77, 180, 244, 1) !important;
  }
  >>> .el-select-dropdown__item {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-select-dropdown__item:hover {
    color: #409eff;
  }
  >>> .el-select-dropdown__item.hover {
    color: #409eff;
  }
  >>> .el-input__icon {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-range-input {
    color: rgba(77, 180, 244, 0.7);
    background: transparent;
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  >>> .el-range-separator {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-radio {
    color: rgba(255, 255, 255, 0.8);
  }
  .item {
    border: 1px solid #4db4f4;
    &:last-of-type {
      .row {
        &:last-of-type {
          border-bottom: 1px solid #4db4f4;
        }
      }
    }
    .row {
      color: rgba(255, 255, 255, 0.8);
      line-height: 36px;
      border-bottom: 1px solid #4db4f4;
      @include flex-box();
      &:last-of-type {
        border-bottom: 0;
      }
      .row-item {
        padding: 5px 0 5px 15px;
        @include flex-item();
        @include flex-box($align: center);
        &:first-of-type {
          border-right: 1px solid #4db4f4;
        }
        .el-input {
          max-width: 300px;
        }
      }
    }
    &.left-item {
      width: 49%;
      margin-right: 2%;
      .row:last-of-type {
        border-bottom: 1px solid #4db4f4;
      }
    }
    &.right-item {
      @include flex-item();
      .row:last-of-type {
        border-bottom: 1px solid #4db4f4;
      }
    }
  }
}
.dialog_camera {
  >>> .el-dialog {
    width: 858px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  >>> .el-dialog__body {
    @include flex-box(center, center);
  }
}
.dialog_isBlack {
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog {
    width: 500px;
    height: 200px;
    margin-top: 40vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  div {
    width: 100%;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Person/personCqmohrss/components/AddPerson.vue